<template>
  <section class="eco-section">
    <div class="container">
      <div class="eco-pic-container" id="ecoPic">
        <img
          :src="require('@/assets/image/eco-section/planet.png')"
          alt="planet"
          class="eco__planet">
        <img
          :src="require('@/assets/image/eco-section/wifi.png')"
          alt="wifi"
          class="eco-ambient eco__wifi">
        <img
          :src="require('@/assets/image/eco-section/chat.png')"
          alt="chat"
          class="eco-ambient eco__chat">
        <img
          :src="require('@/assets/image/eco-section/loc-pin.png')"
          alt="pin"
          class="eco-ambient eco__pin-1">
        <img
          :src="require('@/assets/image/eco-section/phone.png')"
          alt="phone"
          class="eco-ambient eco__phone">
        <img
          :src="require('@/assets/image/eco-section/case.png')"
          alt="case"
          class="eco-ambient eco__case">
        <img
          :src="require('@/assets/image/eco-section/headphones.png')"
          alt="headphones"
          class="eco-ambient eco__headphones">
        <img
          :src="require('@/assets/image/eco-section/loc-pin_2.png')"
          alt="pin"
          class="eco-ambient eco__pin-2">
        <img
          :src="require('@/assets/image/eco-section/play.png')"
          alt="play"
          class="eco-ambient eco__play">
        <img
          :src="require('@/assets/image/eco-section/calendar.png')"
          alt="calendar"
          class="eco-ambient eco__calendar">
      </div>
      <div class="about">
        <div class="about__heading">
          <span>№1</span> Год экосистем
        </div>
        <div class="about__text">
          Вы когда-то раньше слышали про экосистемы? Теперь
          они повсюду — даже на этом сайте! В природе четыре
          стихии связаны между собой для существования жизни,
          в цифровой экосистеме продукты объединены для того,
          чтобы сделать нашу жизнь проще и комфортнее <br><br>
          В этом году МТС применил такой подход и создал
          подписку МТС Premium. Получите ваши привилегии в экосистеме МТС
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap';

export default {
  name: 'v-eco-section',
  mounted() {
    const timelineEco = gsap.timeline({
      scrollTrigger: {
        trigger: '.eco-section',
        start: '-=30%',
        end: '10%',
        scrub: 1,
        onUpdate: (self) => {
          console.log('progress10:', self.progress);
          // const ecoPic = document.getElementById('ecoPic');
          // if (self.progress > 0.5 && !ecoPic.classList.contains('active')) {
          //   ecoPic.classList.add('active');
          //   TweenMax.to('.eco', {
          //     duration: 1,
          //     scale: 1,
          //   });
          // }
          // if (self.progress < 0.5 && ecoPic.classList.contains('active')) {
          //   ecoPic.classList.remove('active');
          //   TweenMax.to('.eco', {
          //     duration: 1,
          //     scale: 0.8,
          //   });
          // }
          // if (self.progress > 0.8 && !ecoPic.classList.contains('active__2')) {
          //   ecoPic.classList.add('active__2');
          //   TweenMax.to('.eco-section', {
          //     opacity: 0,
          //   });
          // }
          // if (self.progress < 0.8 && ecoPic.classList.contains('active__2')) {
          //   ecoPic.classList.remove('active__2');
          //   TweenMax.to('.eco-section', {
          //     opacity: 1,
          //   });
          // }
          // if (self.progress < 0.99) {
          //   document.body.style.background = '#F4F4F4';
          // }
        },
      },
    });
    timelineEco.addLabel('start')
      .to('.eco__planet', {
        rotate: -45,
        scale: 1.7,
        duration: 1,
      })
      .to('.eco__calendar', {
        left: '70%',
        y: -20,
        scale: 1.01,
        rotate: 5,
        duration: 1,
      }, '-=1')
      .to('.eco__wifi', {
        right: '-10%',
        y: 20,
        scale: 1.3,
        rotate: 7,
        duration: 1,
      }, '-=1')
      .to('.eco__chat', {
        right: '-20%',
        y: 40,
        scale: 1.3,
        rotate: 15,
        duration: 1,
      }, '-=1')
      .to('.eco__pin-1', {
        right: '10%',
        y: 40,
        scale: 1.3,
        rotate: 15,
        duration: 1,
      }, '-=1')
      .to('.eco__phone', {
        right: '30%',
        y: 40,
        scale: 1.3,
        rotate: 15,
        duration: 1,
      }, '-=1')
      .to('.eco__case', {
        left: '22%',
        y: 10,
        scale: 1.1,
        rotate: 15,
        duration: 1,
      }, '-=1')
      .to('.eco__headphones', {
        left: '-10%',
        y: 10,
        scale: 1.3,
        rotate: 45,
        duration: 1,
      }, '-=1')
      .to('.eco__pin-2', {
        left: '7%',
        y: -30,
        scale: 1.5,
        rotate: 75,
        duration: 1,
      }, '-=1')
      .to('.eco__play', {
        left: '13%',
        y: -30,
        scale: 1.3,
        rotate: 75,
        duration: 1,
      }, '-=1');
  },
};
</script>

<style lang="scss">

.eco-section {
  position: relative;
  padding-top: 50px;
  min-height: 1000px;

  .container {
    overflow: hidden;
    position: sticky;
    top: 20px;
    padding: 0;
  }

  .about{
    padding: 20px 15px 0;
  }
}
.eco-pic-container{
  overflow: hidden;
  max-width: 100%;
  position: relative;
  padding: 20px 0;
  min-height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.eco{

  &__planet{
    margin: 0 auto;
    display: block;
    width: 182px;
  }

  &-ambient{
    position: absolute;
  }

  &__wifi{
    top: 20px;
    width: 94px;
    height: 94px;
    right: 30%;
  }

  &__chat{
    width: 103px;
    top: 100px;
    right: 18%;
  }

  &__pin-1{
    width: 26px;
    top: 230px;
    right: 27%;
  }

  &__phone{
    width: 54px;
    top: 255px;
    right: 37%;
  }

  &__case{
    width: 74px;
    top: 255px;
    left: 37%;
  }

  &__headphones{
    width: 101px;
    top: 175px;
    left: 14%;
  }

  &__pin-2{
    width: 29px;
    top: 150px;
    left: 27%;
  }

  &__play{
    width: 66px;
    top: 65px;
    left: 21%;
  }

  &__calendar{
    width: 36px;
    top: 40px;
    left: 38%;
  }
}

@media(max-width: 520px){

  .eco{

    &__wifi{
      right: 23vw;
    }

    &__chat{
      right: 7vw;
    }

    &__pin-1{
      right: 25vw;
    }

    &__phone{
      right: 33vw;
    }

    &__case{
      left: 29vw;
    }

    &__headphones{
      left: 5vw;
    }

    &__pin-2{
      left: 22vw;
    }

    &__play{
      left: 19vw;
    }

    &__calendar{
      left: 39vw;
    }
  }
}
@media(max-width: 400px){

  .eco{

    &__wifi{
      right: 20vw;
    }

    &__chat{
      right: 3vw;
    }

    &__pin-1{
      right: 19vw;
    }

    &__phone{
      right: 30vw;
    }

    &__case{
      left: 29vw;
    }

    &__headphones{
      left: 2vw;
    }

    &__pin-2{
      left: 19vw;
    }

    &__play{
      left: 16vw;
    }

    &__calendar{
      left: 38vw;
    }
  }
}
</style>
